import React from 'react';

const GlobalContext = React.createContext();
export const GlobalLoadingContext = React.createContext();

export default GlobalContext;
